import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './styles.css';

class Step extends PureComponent {
  render() {
    const { visible, children } = this.props;

    if (!visible) {
      return null;
    }

    return children;
  }
}

Step.propTypes = {
  visible: PropTypes.bool,
};

export default Step;
